<div class="modal-header">
  <h3 class="modal-title">Artikel auswählen</h3>
</div>

<div class="modal-body">
  <div class="task-customersearch">

    <form name="article-search" class="task-customersearch-form" [formGroup]="form">
      <label>
        <input type="text" class="form-control" id="id_customer"
          name="name"
          formControlName="name"
          autofocus="autofocus"
          [inputSelect]>
      </label>
    </form>
    <div class="whitelist customerlist">
      @if (data.data$ | async; as articleList) {
        @for (article of articleList; track article) {
          <div class="whitelist-item"
            (click)="select(article)"
            [ngClass]="{selected: selected === article.oa_nr}">
            <h4>
              SDS-Nr.: {{ article.sds_nr }}
              @if (article.lock) {
                <span class="label label-warning">Gesperrt</span>
              }
              @if (article.date_deleted) {
                <span class="label label-danger">Gelöscht</span>
              }
            </h4>
            <div>0A-Nr.: {{ article.oa_nr }}</div>
          </div>
        }
      } @else {
        <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
      }

      <loading-or-error
        #loadingOrError
        [loadingWrapper]="data"
        [errorMessage]="'Konnte \'Artikel\' nicht laden'"
        [spinnerSize]="2"
        spinnerName="circle-o-notch">
      </loading-or-error>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-default pull-left" (click)="cancel()" [disabled]="disabledButton">
    Abbrechen
  </button>
  <button class="btn btn-success pull-right" (click)="ok()" [disabled]="disabledButton || !selected">
    Artikel wechseln
    @if (disabledButton) {
      <i class="fa fa-circle-o-notch fa-spin"></i>
    }
  </button>
</div>
